import { createSlice } from '@reduxjs/toolkit';
import { ApiPaginationResponse } from 'src/components/ui/Table/Table.interface';
import {
  COMPANY_SLICE,
  setCompanyDetails,
  setCompanyList,
} from 'src/store/actions/companyActions';
import { Company, ListCompany } from 'src/store/models/Company';

export interface CompanyState {
  companyList: ApiPaginationResponse<ListCompany[]>;
  companyDetails: Company;
}

const initialState: CompanyState = {
  companyList: {
    data: [],
    count: 0,
    ctx: null,
  },
  companyDetails: null,
};

const companySlice = createSlice({
  name: COMPANY_SLICE,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(setCompanyList, (state, action) => {
        state.companyList = action.payload;
      })
      .addCase(setCompanyDetails, (state, action) => {
        state.companyDetails = action.payload;
      });
  },
});

export default companySlice.reducer;
